import { JSX } from "react";
import { HeadExtractoLoteria, INumeroExtracto } from "../interfaces/interfaces";
import { v4 as uuid } from "uuid";
import { AddCerosToNumber, SubFirstCaracter } from "../actions/actions";

interface Props {
  idExtractos: string;
  loteria: HeadExtractoLoteria;
  numerosLoteria: INumeroExtracto[];
}

const GrillaNrosPorLoteria = (props: Props) => {
  const { idExtractos, loteria, numerosLoteria } = props;

  // Usar el nombre que viene del backend por defecto
  let nombreLoteria = `${loteria.Nombre}`;

  // Solo sobrescribir para casos específicos conocidos
  if (loteria.NroLoteria === 3) nombreLoteria = "Bs. As.";
  if (loteria.NroLoteria === 4) nombreLoteria = "Oro(Uru)";

  return (
    <div id={`${idExtractos}`} className="extractoIndividual">
      <div className="extractosArribaContainer">
        <div className="extractosArribaContainer">
          <div className="extractoBloqueTit">
            <div className="extractoTitulo">LOTERIA</div>
            <div className="extractoLoteria">{nombreLoteria}</div>
          </div>
        </div>
      </div>
      <div className="extractosAbajoContainer">
        <div className="extractoBloqueCol">
          {numerosLoteria && getNumeroItems(numerosLoteria, false)}
        </div>
        <div className="extractoBloqueCol">
          {numerosLoteria && getNumeroItems(numerosLoteria, true)}
        </div>
      </div>
    </div>
  );
};

function getNumeroItems(numeros: INumeroExtracto[], parImpar: boolean) {
  let numerosElements: JSX.Element[] = [];

  for (const numero of numeros) {
    let keyC = `${numero.Valor}${uuid()}`;

    let numeroLoteria =
      numero.idModalidad !== 30
        ? AddCerosToNumber(numero.Valor, 4)
        : AddCerosToNumber(numero.Valor, 2);

    if (numero.NroLoteria === 4) numeroLoteria = SubFirstCaracter(numeroLoteria);

    if (parImpar && numero.Ubicacion >= 11) {
      numerosElements.push(
        <div key={`p${keyC}`} className="extractoBloqueNum">
          <div className="extractoPosición">{`${numero.Ubicacion}º`}</div>
          <div className="extractoNumero">{`${numeroLoteria}`}</div>
        </div>
      );
    }

    if (!parImpar && numero.Ubicacion <= 10) {
      numerosElements.push(
        <div key={`pi${keyC}`} className="extractoBloqueNum">
          <div className="extractoPosición">{`${numero.Ubicacion}º`}</div>
          <div
            className={
              numero.Ubicacion === 1
                ? "extractoNumero extractoPrimero"
                : "extractoNumero"
            }
          >{`${numeroLoteria}`}</div>
        </div>
      );
    }
  }

  return numerosElements;
}

export default GrillaNrosPorLoteria;
